import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box, FormControlLabel, IconButton, Switch } from '@mui/material';

import { classes } from './styles';

import type { TSortableColumn } from '../types';

const SortableField = ({
  field,
  handleFieldSwitchChange
}: {
  field: TSortableColumn;
  handleFieldSwitchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition } =
    useSortable({ id: field.id });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition
  };

  return (
    <Box key={field.id} ref={setNodeRef} style={style} sx={classes.sortableField} {...attributes}>
      <IconButton ref={setActivatorNodeRef} {...listeners}>
        <DragIndicatorIcon sx={{ fontSize: 16 }} />
      </IconButton>
      <FormControlLabel
        label={field.label}
        labelPlacement="start"
        control={
          <Switch
            checked={field.enabled}
            name={field.id}
            onChange={handleFieldSwitchChange}
            sx={field.enabled ? classes.switchActive : classes.switch}
          />
        }
        sx={
          !field.enabled
            ? { ...classes.sortableSwitchLabels, ...classes.labelActive }
            : classes.sortableSwitchLabels
        }
      />
    </Box>
  );
};

export default SortableField;
